import { useAuth } from '../contexts/AuthContext';

interface SignInButtonProps {
  className?: string;
}

export function SignInButton({ className }: SignInButtonProps) {
  const { login } = useAuth();

  return (
    <button
      onClick={() => login('google')}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-disney-blue-500 dark:bg-disney-blue-600 px-6 py-3 font-medium text-sm text-white shadow-sm transition-all duration-200 hover:bg-disney-blue-600 dark:hover:bg-disney-blue-700 hover:shadow-md active:scale-[0.98] ${className}`}
    >
      <GoogleIcon />
      Sign in with Google
    </button>
  );
}

function GoogleIcon() {
  return (
    <svg className="w-5 h-5" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
        fill="white"
      />
    </svg>
  );
}
